import { posthogClient } from './posthog';

export const checkoutLogger = {
  started(plan: string) {
    posthogClient()?.logger.info('checkout_started', { plan });
  },
  failed(plan: string, reason: string | undefined) {
    posthogClient()?.logger.error('checkout_failed', { plan, reason });
  },
  completed(plan: string) {
    posthogClient()?.logger.info('checkout_completed', { plan });
  },
};
